<div class="relative w-full h-full">
  <div class="m-1 absolute z-50 left-0 top-0">
    <button mat-flat-button (click)="toggleStyle()">Toggle Style</button>
  </div>
  <div #map class="w-full h-[312px]"></div>
</div>
